// extracted by mini-css-extract-plugin
export default {"root":"DuplicateListingButton_root__hFsp7","button":"DuplicateListingButton_button__1VXDW","icon":"DuplicateListingButton_icon__Cusam","error":"DuplicateListingButton_error__RMlrg"};